// Packages
import { Form } from '@/services/form';

// Mixins
import trackingMixins from '@/mixins/tracking/sdk';
import { getFormatedUtms } from '@/mixins/utm';
import { API_URLS } from '@/api/pumba/urls';

const formObject = {
    // User
    name: '',
    phone: '',
    email: '',
    email_confirmation: '',
    company_name: '',

    // Mixpanel distinct_id
    distinct_id: '',

    utms: getFormatedUtms(),
};
// TODO: remove spread and other states if no used in this file, check qualification branch
export const state = {
    form: new Form(formObject),
    spreadArrayValues: [],
    otherSpreadValue: '',
    sending: false,
    loading: false,
};

export const getters = {
    form: (states) => states.form,
    loading: (states) => states.loading,
    spreadArrayValues: (states) => states.spreadArrayValues,
    otherSpreadValue: (states) => states.otherSpreadValue,
};

export const mutations = {
    ['SET_SENDING'](states, payload) {
        states.sending = payload;
    },

    ['UPDATE_LOADING_STATUS'](states, status) {
        states.loading = status;
    },

    ['UPDATE_FORM_VALUE'](states, { index, value }) {
        states.form[index] = value;
    },

    ['UPDATE_DISTINCT_ID'](states, value) {
        states.form.distinct_id = value;
    },

    ['UPDATE_ECOMMERCE_SEGMENT'](states, value) {
        states.form.is_ecommerce_segment = value;
    },

    ['RESET_FORM'](states) {
        states.form.reset();
    },

    ['UPDATE_SPREAD_ARRAY_VALUES'](states, arr) {
        states.spreadArrayValues = arr;
    },

    ['UPDATE_OTHER_SPREAD_VALUE'](states, value) {
        states.otherSpreadValue = value;
    },
};

export const actions = {
    async submit({ state: states, commit }) {
        const { distinct_id } = trackingMixins.data();

        try {
            commit('UPDATE_LOADING_STATUS', true);

            commit('UPDATE_DISTINCT_ID', distinct_id);
            // dispatch('formatSpreadForm');

            await states.form.post(API_URLS.AUTH.REGISTER, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            commit('UPDATE_SPREAD_ARRAY_VALUES', []);
            commit('UPDATE_OTHER_SPREAD_VALUE', '');
        } catch (error) {
            throw error;
        } finally {
            commit('UPDATE_LOADING_STATUS', false);
        }
    },

    formatSpreadForm({ state: states, commit }) {
        if (states.otherSpreadValue) {
            states.spreadArrayValues.push(states.otherSpreadValue);
        }

        const slicedSpreadValues = states.spreadArrayValues.join(', ');

        commit('UPDATE_FORM_VALUE', { index: 'spread', value: slicedSpreadValues });
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
